module.exports = __webpack_public_path__ + "static/media/Super73_Logo.ca3fd7ef.avif";